import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@repo/ui-web';

export function DialogShowcase() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button size="md" variant="outline">
          Open dialog
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="font-display text-xl font-semibold">Dialog title</DialogTitle>
          <DialogDescription>Short description and actions.</DialogDescription>
        </DialogHeader>
        <div className="flex justify-end gap-2">
          <Button variant="outline" size="md">
            Cancel
          </Button>
          <Button size="md">Confirm</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
